import { render, staticRenderFns } from "./Risk.vue?vue&type=template&id=380ed4ee&scoped=true&"
import script from "./Risk.vue?vue&type=script&lang=js&"
export * from "./Risk.vue?vue&type=script&lang=js&"
import style0 from "./Risk.vue?vue&type=style&index=0&id=380ed4ee&scoped=true&lang=css&"
import style1 from "./Risk.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ed4ee",
  null
  
)

export default component.exports